export class CardStackDataEvent
{
    static ANGLE_CHANGED: string = 'CardStackDataEvent.ANGLE_CHANGED';
    static BLOCKED_BY_PLAYER_CHANGED: string = 'CardStackDataEvent.BLOCKED_BY_PLAYER_CHANGED';
    static TITLE_CHANGED: string = 'CardStackDataEvent.TITLE_CHANGED';
    static ID_CHANGED: string = 'CardStackDataEvent.ID_CHANGED';
    static LOCKED_CHANGED: string = 'CardStackDataEvent.LOCKED_CHANGED';
    static MASTER_LOCKED_CHANGED: string = 'CardStackDataEvent.MASTER_LOCKED_CHANGED';
    static ON_TABLE_CHANGED: string = 'CardStackDataEvent.ON_TABLE_CHANGED';
    static USED_BY_PLAYER_CHANGED: string = 'CardStackDataEvent.USED_BY_PLAYER_CHANGED';
    static WIDTH_CHANGED: string = 'CardStackDataEvent.WIDTH_CHANGED';
    static HEIGHT_CHANGED: string = 'CardStackDataEvent.HEIGHT_CHANGED';
    static X_CHANGED: string = 'CardStackDataEvent.X_CHANGED';
    static Y_CHANGED: string = 'CardStackDataEvent.Y_CHANGED';
    static Z_CHANGED: string = 'CardStackDataEvent.Z_CHANGED';
    static FLIPPED: string = 'CardStackDataEvent.FLIPPED';
    static SHUFFLED: string = 'CardStackDataEvent.SHUFFLED';
}
